import React from "react";
import starIcon from "../../assets/images/icons/star.svg";
import oferteoIcon from "../../assets/images/icons/oferteo.png";
import googleIcon from "../../assets/images/icons/google.png";

function StatsBar() {
    return (
        <div className="stats-bar">
            <div className="container stats-bar-inner">
                <div className="stats-col">
                    <span className="stats-value">14+</span>
                    <span className="stats-label">Lat na rynku</span>
                </div>
                <div className="stats-col">
                    <span className="stats-value">20 000+</span>
                    <span className="stats-label">Zadowolonych klientów</span>
                </div>
                <div className="stats-col">
                    <span className="stats-value">2,1 MLD+</span>
                    <span className="stats-label">Wartości zawartych umów</span>
                </div>
                <div className="stats-col">
                    <div className="stats-rating-row">
                        <span className="stats-value">4,99</span>
                        <div className="stats-stars">
                            {[1,2,3,4,5].map(i => (
                                <img key={i} src={starIcon} alt="★" className="stats-star"/>
                            ))}
                        </div>
                    </div>
                    <div className="stats-review-row">
                        <span className="stats-label">Ponad 350 opinii na</span>
                        <img src={oferteoIcon} alt="Oferteo" className="stats-platform-icon"/>
                        <span className="stats-label">Oferteo oraz</span>
                        <img src={googleIcon} alt="Google" className="stats-platform-icon"/>
                        <span className="stats-label">Google</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StatsBar;
